import { PEOPLE } from './types';
export const getPeopleList = payload => {
  return ({
    type: PEOPLE.GET_PEOPLE,
    payload
  });
}

export const getPeopleListSuccess = (response) => {
  return ({
    type: PEOPLE.GET_PEOPLE_SUCCESS,
    response,
  })
};

export const getPeopleListFailure = (error) => ({
  type: PEOPLE.GET_PEOPLE_FAILURE,
  error
});